import * as Yup from 'yup';

const ValidationLogo = Yup.object({
    statusLogo: Yup.string().required("El campo es requerido"),
});

export default ValidationLogo